import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircle } from "lucide-react";
import { useCreateContract } from "../api/queries";
import {
  ContractCreateTour,
  useContractCreateTour,
} from "../tour/ContractCreateTour";
import { ContractForm } from "../ui/ContractForm";

export function ContractCreatePage() {
  const tour = useContractCreateTour();
  const nav = useNavigate({ from: "/app/contracts/new" });
  const createContract = useCreateContract();

  return (
    <>
      <Header />
      <Main>
        <ContractCreateTour
          run={tour.run}
          onCallback={tour.handleJoyrideCallback}
        />
        {/* Page Header */}
        <div className="mb-6">
          <div className="mb-4 flex items-start justify-between">
            <div className="flex-1">
              <div className="mb-2 flex items-center gap-3">
                <h1 className="font-bold text-3xl">ສ້າງສັນຍາໃໝ່</h1>
                <Button
                  variant="ghost"
                  size="icon"
                  className="size-7 rounded-full"
                  onClick={tour.startTour}
                >
                  <HelpCircle className="size-5" />
                </Button>
              </div>
              <p className="text-muted-foreground text-sm">
                ກະລຸນາຕື່ມຂໍ້ມູນສັນຍາໃໝ່. ທຸກຊ່ອງທີ່ມີເຄື່ອງຫມາຍ * ແມ່ນຊ່ອງບັງຄັບ.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => nav({ to: "/app/contracts" })}
              >
                <ArrowLeftIcon className="h-4 w-4" />
                ກັບ
              </Button>
            </div>
          </div>
        </div>

        {/* Form Container */}
        <div className="mx-auto max-w-5xl">
          <ContractForm
            onSubmit={async (vals) => {
              try {
                await createContract.mutateAsync({
                  ...vals,
                  // Ensure nullable fields are null (not undefined) for CreateContractFormDTO compatibility
                  customerId: vals.customerId ?? null,
                  quotationDocumentId: vals.quotationDocumentId ?? null,
                  departmentId: vals.departmentId ?? null,
                  employeeId: vals.employeeId ?? null,
                  responsiblePersonId: vals.responsiblePersonId ?? null,
                  documents: vals.documents || [],
                });
                nav({ to: "/app/contracts" });
              } catch (error) {
                // Error is already handled by the mutation hook
                console.error("Failed to create contract:", error);
              }
            }}
            submitting={createContract.isPending}
          />
        </div>
      </Main>
    </>
  );
}
